import SimplestEntry from "./models/SimplestEntry";
import * as shopsNameData from './tables/shops.table.json';
import { ITwoFactorTable } from "./interfaces/ITable";

const ShopTableData: ITwoFactorTable<SimplestEntry> = shopsNameData as ITwoFactorTable<SimplestEntry>;

export default ShopTableData;
